import React from 'react'

import { addLocaleData } from 'react-intl'
import { IntlProvider } from 'react-intl'
import { Route, Switch } from 'react-router-dom'

import en from './locales/en.json'
import enLocale from 'react-intl/locale-data/en'
//eslint-disable-next-line
// import esMoment from 'moment/locale/es'
import es from './locales/es.json'
import esLocale from 'react-intl/locale-data/es'
//eslint-disable-next-line
// import ptMoment from 'moment/locale/pt'
import pt from './locales/pt.json'
import ptLocale from 'react-intl/locale-data/pt'

import moment from 'moment'
import Routes from '../Routes'
import { withRouter } from 'react-router'

addLocaleData([...enLocale, ...esLocale, ...ptLocale])

const messages = {
    en,
    es,
    pt
}

const Error404 = () => <h1>404</h1>

class MyIntlProvider extends React.Component {
    render() {
        let locale = this.props.match.params.lang !== undefined ? this.props.match.params.lang : 'es'
        moment.locale(locale)
        return (
            <div>
                <IntlProvider locale={locale} messages={messages[locale]}>
                    <Routes />
                </IntlProvider>
            </div>
        )
    }
}

MyIntlProvider = withRouter(MyIntlProvider)

const IntlRoute = () => {
    return (
        <div>
            <Switch>
                <Route path="/:lang(es|en|pt)?" component={MyIntlProvider} />
                <Route component={Error404} />
            </Switch>
        </div>
    )
}

export default IntlRoute



// WEBPACK FOOTER //
// ./src/i18n/index.js